import "./GradientIcon.css";

type GradientIconProps = {
  src: string;
  alt: string;
  mainContainerClassName?: any;
  style?: any;
};
const GradientIcon = ({
  src,
  alt,
  mainContainerClassName,
  style,
}: GradientIconProps) => {
  return (
    <div
      className={`gradient_img_container gradient_bg ${mainContainerClassName}`}
      style={style}
    >
      <img src={src} alt={alt} />
    </div>
  );
};

export default GradientIcon;
